import { QueryClientProvider } from '@tanstack/react-query';
import { GlobalStyles } from '@village/ui';
import { SchedulerErrorBoundaryWithRouter } from 'components/error-boundary/error-boundary-with-router';
import { AppOptionsContextProvider } from 'contexts/app-options';
import { BookingContextProvider } from 'contexts/booking';
import { CaptureCountlyEventsContextProvider } from 'contexts/capture-countly-events';
import { queryClient } from 'modules/react-query';
import { FC } from 'react';
import { HashRouter } from 'react-router';
import { AppRoutes } from 'routes';
import { CustomGlobalStyles, MainContainer } from 'theme';
import { ThemeProvider } from 'theme/theme-provider';
import { MainAppOptions } from 'types';

interface Props {
    options: MainAppOptions;
}

const MainScheduler: FC<Props> = ({ options }) => (
    <ThemeProvider>
        <MainContainer>
            <HashRouter>
                <AppOptionsContextProvider options={options}>
                    <QueryClientProvider client={queryClient}>
                        <SchedulerErrorBoundaryWithRouter>
                            <BookingContextProvider>
                                <SchedulerErrorBoundaryWithRouter>
                                    <CaptureCountlyEventsContextProvider>
                                        <AppRoutes />
                                    </CaptureCountlyEventsContextProvider>
                                </SchedulerErrorBoundaryWithRouter>
                            </BookingContextProvider>
                        </SchedulerErrorBoundaryWithRouter>
                        <GlobalStyles />
                        <CustomGlobalStyles />
                    </QueryClientProvider>
                </AppOptionsContextProvider>
            </HashRouter>
        </MainContainer>
    </ThemeProvider>
);

export { MainScheduler };
